import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { UploadFolderButton } from '../journey/UploadButton';
import { MultipleErrorToast } from '../utils/Utils';

const useStyles = makeStyles(() => ({
  popupContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  templates: {
    height: '60vh',
    width: '97%',
    background: '#f3f4f7',
    padding: '15px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    overflowY: 'auto',
  },
  inputField: {
    width: '90%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid gray',
    outline: 'none',
    marginTop: '5px',
    background: 'transparent',
  },

  upload: {
    border: '1px solid gray',
    padding: '10px',
    marginTop: '5px',
    width: '90%',
    borderRadius: '5px',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  optional_field: {
    color: '#667085',
  },
  addAction: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid gray',
    padding: '0px 10px',
  },
  videoInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    justifyContent: 'center',
  },
  interaction: {
    background: '#fefefe',
    marginTop: '10px',
    marginBottom: '5px',
    padding: '10px',
    display: 'flex',
    gap: '20px',
    borderRadius: '5px',
  },
  thumbnail: {
    width: '80px',
    height: '70px',
  },
  flag: {
    width: '70px',
    height: '70px',
    background: '#EBE9FE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },
}));

export default function InteractionForm({
  setInteractionsList,
  interactionsList,
  handleChangeForm,
  interactionTypes,
  setUrlValue,
  urlValue,
  handleUrlChange,
  handleBack,
  clearState,
  editData,
  isAdd,
  thumbIndex,
}) {
  const classes = useStyles();

  const INITIAL_INTERACTION_FORM = {
    title: '',
    overview: '',
    activityTypeId: '',
    duration: '',
    link: '',
  };
  const [interactionForm, setInteractionForm] = useState(INITIAL_INTERACTION_FORM);

  useEffect(() => {
    if (editData) {
      setInteractionForm(editData);
    }
  }, []);

  const handleValidation = () => {
    let isCorrect = true;
    const errors = [];

    if (!interactionForm.title) {
      isCorrect = false;
      errors.push('Please enter interaction title.');
    }
    if (!interactionForm.duration) {
      isCorrect = false;
      errors.push('Please enter duration.');
    }
    if (interactionForm.duration && Number.isNaN(Number(interactionForm.duration))) {
      isCorrect = false;
      errors.push('Please enter a number for duration.');
    }
    if (!urlValue) {
      isCorrect = false;
      errors.push('Please enter a valid interaction link.');
    }
    if (!interactionForm.activityTypeId) {
      isCorrect = false;
      errors.push('Please select interaction type.');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isCorrect;
  };

  const handleInteractionSave = () => {
    if (!handleValidation('interaction')) return;
    const interactionData = {
      title: interactionForm.title,
      activityTypeId: interactionForm.activityTypeId,
      duration: interactionForm.duration,
      link: urlValue,
    };

    if (interactionForm.overview) {
      interactionData.overview = interactionForm.overview;
    }

    if (interactionForm.id) {
      const temp = interactionsList?.filter((i) => i.id !== interactionForm.id);
      interactionData.id = interactionForm.id;
      setInteractionsList([...temp, interactionData]);
    } else {
      if (!isAdd) {
        interactionsList?.splice(thumbIndex, 1);
      }
      setInteractionsList([...interactionsList, interactionData]);
    }
    clearState();
  };

  return (
    <>
      <Grid className={classes.templates}>
        <Typography variant="h6">Add Interaction</Typography>
        <Grid>
          <Typography className={classes.required_field}>Interaction Title</Typography>
          <input
            placeholder="ex: EV Roadtrip"
            className={classes.inputField}
            value={interactionForm.title}
            onChange={(e) => handleChangeForm(e, 'title', interactionForm, setInteractionForm)}
          />
        </Grid>
        <Grid>
          <Typography className={classes.optional_field}>Interaction Goal</Typography>
          <input
            placeholder="Enter interaction goal here"
            className={classes.inputField}
            value={interactionForm.overview}
            onChange={(e) => handleChangeForm(e, 'overview', interactionForm, setInteractionForm)}
          />
        </Grid>
        <Grid>
          <Typography className={classes.required_field}>Type of Interaction</Typography>
          <Grid>
            {interactionTypes?.map((type) => (
              <Grid key={type.id} style={{ display: 'flex', gap: '5px', margin: '10px 0px 0px 10px' }}>
                <input
                  type="radio"
                  checked={interactionForm.activityTypeId === type.id}
                  value={type.id}
                  onChange={(e) => handleChangeForm(e, 'activityTypeId', interactionForm, setInteractionForm)}
                />
                <Typography style={{ color: '#1D2939' }}>{type.title}</Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid>
          <Typography className={classes.required_field}>Upload Interaction </Typography>
          <Grid className={classes.upload}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid item>
                <UploadFolderButton name="upload_s3_interaction" urlValue={urlValue} setUrlValue={setUrlValue} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Typography className={classes.required_field}>Duration (in seconds) </Typography>
          <input
            placeholder="Enter duration here"
            className={classes.inputField}
            value={interactionForm.duration}
            onChange={(e) => handleChangeForm(e, 'duration', interactionForm, setInteractionForm)}
          />
        </Grid>
        <Grid>
          <Typography className={classes.required_field}>Interaction Link</Typography>
          <input
            placeholder="Enter interaction link"
            className={classes.inputField}
            value={urlValue === 'null' ? '' : urlValue}
            onChange={handleUrlChange}
          />
        </Grid>
      </Grid>
      <Grid style={{ display: 'flex' }}>
        <Button onClick={handleBack} variant="outlined">
          Back
        </Button>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
          <Button variant="contained" color="primary" onClick={handleInteractionSave}>
            Continue
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
